
<project-details-info-features-stages [project]="project"></project-details-info-features-stages>

  <!-- PROJECT details features-->
  <article class="project-details-features" [ngClass]="{'with-overlay': actionFeaturesStatus != STATUS_DONE && actionFeaturesStatus != STATUS_LOADING }">
      <core-layout-modal-feedback class="modal-feedback" *ngIf="actionFeaturesStatus == STATUS_NOT_ALLOWED" 
        [type]="'warning'"
        [message]="'Forbidden'"
        [text]=" warningMessage + ' Please contact your admin for additional support.'"
        [buttonText]="'OK'" (action)="onUpdateFeaturesError($event)">
      </core-layout-modal-feedback>
      <core-layout-modal-feedback class="modal-feedback" *ngIf="actionFeaturesStatus == STATUS_ERROR" 
        [type]="'fail'"
        [message]="'Error'"
        [text]=" warningMessage + ' Please try again.<br/> If the error persists, please reach out to our support team through the Help Me button.'"
        [buttonText]="'OK'" (action)="onUpdateFeaturesError($event)">
      </core-layout-modal-feedback>
    <div class="project-details-features-main">
      <div class="project-details-features-content-avatars">
        <!-- PROJECT OWNER AND ASIGNEE -->
        <div class="project-details-features-owner">
          <core-helper-box-header-user-date
          [date]="project.date_created"
          [user]="project.user_owner"
          [preText]="'<strong>Created by</strong>'"
          ></core-helper-box-header-user-date>
        </div>
        <!-- CONTROL ASIGNEE is set!!!-->
        <div class="project-details-features-asignee">
          <core-helper-box-header-user-assignee 
            [user]="project.user_assigned" 
            [preText]="(interactiveAsignee || project.user_assigned) ? '<strong>Assigned to</strong>' : '<strong>Not assigned</strong>'"
            [interactive]="interactiveAsignee" 
            [users]="interactiveAsignee ? assigners : []"
            (onSelectAssignee)="onSelectAssignee($event)">
          </core-helper-box-header-user-assignee>
          <!-- DUEDATE - CALENDAR DATEPICKER -->
          <div class="project-details-features-duedate" [ngClass]="{'due-date-forbidden': !interactiveCalendar, 'empty-assignee' : (!project.user_assigned && !interactiveAsignee)  }">
            <core-helpers-forms-button-icon 
              [text]="interactiveCalendar ? due.text : (project.due_date | date:'dd MMM yyyy')"
              [icon]="due.icon" 
              (click)="interactiveCalendar ? toggleCalendar() : null">
            </core-helpers-forms-button-icon>
          </div>
        </div>
      </div>
    </div>
    <div class="project-details-features-datepicker">
        <!-- this formatted date should not be changed because it is a parameter to the datepicker -->
      <core-helpers-forms-datepicker
        [selectedDate]="project.due_date | date: 'yyyy-MM-dd'"
        [hidden]="!showCalendar"
        [theme]="'dp-duedate'"
        (selectDate)="onSelectDate($event)"
        (close)="onClose()"
        ></core-helpers-forms-datepicker>
    </div>
  </article>
  <!-- End PROJECT details features -->
